var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('div',{staticClass:"v-task-tags"},_vm._l((_vm.tags),function(tag){return _c('span',{key:tag.tag_id,on:{"click":function($event){$event.stopPropagation();return _vm.onClick(tag)}}},[_vm._v(" #"+_vm._s(_vm.isCN ? tag.tag_name : tag.tag_name)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }